// Mock data for Service2Success Talent Solutions

export const mockData = {
  // Contact form submissions (mock)
  contactSubmissions: [],
  
  // Resume submissions (mock)
  resumeSubmissions: [],
  
  // Company info
  company: {
    name: "Service2Success Talent Solutions",
    shortName: "S2S",
    tagline: "Translating Experience into Career Success",
    location: "Batesville, Indiana",
    phone: "513-668-0344",
    email: "rich@s2stalent.com",
    regions: ["Cincinnati", "Indianapolis", "Tri-State Region (OH, IN, KY)", "Nationwide"]
  },
  
  // Services
  services: [
    {
      id: 1,
      title: "Recruiting & Talent Acquisition",
      description: "Direct hire recruiting for engineering, manufacturing, and technical roles",
      items: [
        "Direct hire recruiting",
        "Skilled trades recruiting",
        "Engineering and technical roles",
        "Manufacturing workforce recruiting"
      ]
    },
    {
      id: 2,
      title: "Veteran Hiring Solutions",
      description: "Specialized support for military talent transition",
      items: [
        "Military talent sourcing",
        "SkillBridge program partnerships",
        "Veteran candidate pipelines",
        "Military-to-civilian transition guidance"
      ]
    },
    {
      id: 3,
      title: "Candidate Support",
      description: "Comprehensive career transition assistance",
      items: [
        "Resume optimization",
        "LinkedIn profile optimization",
        "Career transition guidance for veterans",
        "Interview preparation"
      ]
    }
  ],
  
  // Industries
  industries: [
    {
      name: "Manufacturing & Distribution",
      description: "Production, assembly, and distribution operations"
    },
    {
      name: "Engineering",
      description: "Industrial, mechanical, and process engineering"
    },
    {
      name: "Skilled Trades",
      description: "Electricians, welders, machinists, and technicians"
    },
    {
      name: "Supply Chain & Logistics",
      description: "Operations, planning, and coordination"
    },
    {
      name: "Quality Assurance & Control",
      description: "QA/QC engineers and managers"
    },
    {
      name: "Maintenance & Facilities",
      description: "EHS, safety, and compliance roles"
    }
  ],
  
  // Operations highlights
  operations: [
    {
      icon: "Target",
      title: "Nationwide Support with Midwest Roots",
      description: "Local expertise, national reach"
    },
    {
      icon: "Briefcase",
      title: "Direct Hire, Salary-based Placements",
      description: "No contract or temp positions"
    },
    {
      icon: "Clock",
      title: "Client Needs Assessment in 30 Minutes",
      description: "Quick response, faster results"
    },
    {
      icon: "Users",
      title: "Targeted Outreach & Human Evaluation",
      description: "Quality over quantity approach"
    },
    {
      icon: "CheckCircle",
      title: "Qualified Shortlists for Quick Decisions",
      description: "Pre-vetted, ready-to-interview candidates"
    },
    {
      icon: "Handshake",
      title: "Offers, Onboarding, & Ongoing Support",
      description: "Partnership through placement and beyond"
    }
  ],
  
  // Differentiators
  differentiators: [
    {
      icon: "Zap",
      title: "Lean by Design",
      description: "Faster execution with no agency overhead"
    },
    {
      icon: "Award",
      title: "Capability First",
      description: "From field experience to business value"
    },
    {
      icon: "Shield",
      title: "Veteran Access",
      description: "Mission-driven, disciplined, high-performing talent"
    },
    {
      icon: "Star",
      title: "White-Glove Service",
      description: "High-touch, clear expectations, no noise"
    },
    {
      icon: "Lock",
      title: "Brand Protection",
      description: "Every interaction reflects your company standards"
    }
  ],
  
  // Scope
  scope: {
    functionalDomains: [
      "Supply Chain & Logistics",
      "Manufacturing & Distribution",
      "Warehouse Operations",
      "Industrial Engineering",
      "Quality Assurance & Control",
      "Maintenance & Facilities",
      "EHS Safety & Compliance"
    ],
    keyRoles: [
      "Operators",
      "Coordinators",
      "Technicians",
      "Supervisors",
      "Managers",
      "QA/QC",
      "Engineers"
    ]
  }
};
